import { Price, PriceInterval } from 'shared/types/price';

// The backend returns a lifetime price all year round, so its presence means nothing. A campaign
// is what makes it a deal: a coupon the backend attached to it, or the price's own end date.
export const isLifetimeDealPrice = ({ interval, expires, coupon }: Price) =>
  interval === PriceInterval.Lifetime && (!!expires || !!coupon);
